import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import AdminNotesComponent from "../../components/applicationComponents/administrativeNotes/administrativeNotesComponent";

export default function AdminNotesPage() {
  const [id, setId] = useState("");
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const idParam = searchParams.get("id");
    setId(idParam ?? "");
  }, []);
  return (
    <>
      <div className="flex flex-col align-items-start height-calc px-2">
        <AdminNotesComponent disabled={false} id={id} />
      </div>
    </>
  );
}
